<template>
    <div>
        <div>
            <!-- SELECT CURRENCY -->
            <el-form-item
                :label="$t.__('dashboard.forms.TurnoverSettingForm.select_card_currency')"
                prop="currency"
            >
                <CurrencyInput :modelValue="form.currency" @update:modelValue="updateCurrency" />
            </el-form-item>
            <!-- RADIO TAX -->
            <el-form-item :label="$t.__('common.actions.select_tax_display')" prop="taxMode">
                <CompassRadioGroup v-model="form.taxMode" direction="vertical">
                    <CompassRadio modelValue="exc" :label="$l10n.__('HT')" />
                    <CompassRadio modelValue="inc" :label="$l10n.__('TTC')" />
                </CompassRadioGroup>
            </el-form-item>
        </div>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import CurrencyInput from 'vcomponents/inputs/CurrencyInput.vue';

export default {
    components: {
        CurrencyInput,
    },
    mixins: [SettingsFormMixin],
    data() {
        return {
            turnoverRules: {
                currency: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez sélectionner une devise'),
                        trigger: 'submit',
                    },
                ],
                taxMode: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'submit',
                    },
                ],
            },
        };
    },
    mounted() {
        this.$emit('set-rules', this.turnoverRules);
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateCurrency(currency) {
            this.form.currency = currency.name;
        },
    },
};
</script>
